import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import style from './Contact.css';
import FormComponent from '../../components/FormComponent';
import Form from '../../components/Form';

const initialState = {
  firstName: '',
  lastName: '',
  email: '',
  phone: '',
  message: '',
  isLoading: false,
  formMessage: '',
  recaptchaFailed: false,
  recaptchaCompleted: false
};

class Contact extends React.Component {
  static contextTypes = { fetch: PropTypes.func.isRequired };

  static propTypes = {
    title: PropTypes.string.isRequired
  };

  state = {
    ...initialState,
    firstName: this.props.firstName,
    lastName: this.props.lastName,
    email: this.props.username
  };

  componentDidMount() {
    setTimeout(() => {
      window.grecaptcha.render('g-recaptcha', {
        sitekey: '6Ld700YUAAAAAECUF4wYras641n5pZSopQBoEBOL',
        callback: this.grecaptchaCallback
      });
    }, 300);
  }

  grecaptchaCallback = async response => {
    const res = await this.context.fetch('/api/recaptcha', {
      method: 'POST',
      body: JSON.stringify({
        'grecaptcha-response': response
      })
    });

    if (res.ok) {
      this.setState({
        recaptchaFailed: false,
        recaptchaCompleted: true
      });
    }
  };

  handleChange = event => {
    this.setState({
      [event.target.name]: event.target.value
    });
  };

  handleSubmitAsync = () => {
    const handleSubmitAsync = async () => {
      if (
        !this.state.recaptchaCompleted &&
        window.grecaptcha.getResponse() === ''
      ) {
        this.setState({
          recaptchaFailed: true
        });
        return;
      }

      const { firstName, lastName, email, phone, message } = this.state;
      await this.context.fetch('/api/contact', {
        method: 'POST',
        body: JSON.stringify({
          firstName,
          lastName,
          email,
          phone,
          message
        })
      });
    };

    handleSubmitAsync()
      .then(() => {
        window.toastr.success('Email sent!');
        this.setState({
          ...initialState,
          firstName: this.props.firstName,
          lastName: this.props.lastName,
          email: this.props.username
        });
      })
      .catch(err => {
        window.toastr.error('Email failed to send!');
        this.setState({
          ...initialState,
          firstName: this.props.firstName,
          lastName: this.props.lastName,
          email: this.props.username,
          formMessage: err.message
        });
      });
  };

  handleSubmit = event => {
    this.handleSubmitAsync();
    event.preventDefault();
  };

  render() {
    return (
      <div className="container-fluid">
        <div className="row">
          <div className={style.panel}>
            <Form
              title={this.props.title}
              isLoading={this.state.isLoading}
              loadingMessage="Sending email..."
              onFormSubmit={this.handleSubmit}
            >
              <FormComponent
                name="firstName"
                value={this.state.firstName}
                onChange={this.handleChange}
                placeholder="First name"
                disabled={!!this.props.firstName}
              />
              <FormComponent
                name="lastName"
                value={this.state.lastName}
                onChange={this.handleChange}
                placeholder="Last name"
                disabled={!!this.props.lastName}
              />
              <FormComponent
                name="email"
                type="email"
                pattern="\S+@\S+\.\S+"
                title="Eight a valid email address"
                value={this.state.email}
                onChange={this.handleChange}
                placeholder="Email"
                required
                disabled={!!this.props.username}
              />
              <FormComponent
                name="phone"
                value={this.state.phone}
                onChange={this.handleChange}
                placeholder="Phone"
              />
              <FormComponent
                name="message"
                type="textArea"
                value={this.state.message}
                onChange={this.handleChange}
                placeholder="Type your message here..."
              />
              <div
                className={this.state.recaptchaFailed ? style.recaptcha : null}
              >
                <div id="g-recaptcha" />
                {this.state.recaptchaFailed
                  ? <p className={style.recaptchaFailedMessage}>
                      Please verify that you are not a robot.
                    </p>
                  : null}
              </div>
            </Form>
          </div>
        </div>
      </div>
    );
  }
}

export default connect(state => ({
  username: state.auth.user.username,
  firstName: state.auth.user.firstName,
  lastName: state.auth.user.lastName
}))(withStyles(style)(Contact));



// WEBPACK FOOTER //
// ./src/routes/contact/Contact.js